// libs
import React from 'react';

import { CheckmarkOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
// components
import { Box } from '@lyearn/ui';

import RatingItemNumber from '../RatingItemNumber';
// types
import { RatingItemProps } from './types';

const RatingItem = (props: RatingItemProps) => {
  const { value, selected = false, className = '' } = props;
  if (!value) {
    return null;
  }
  return (
    <Box className={cn('flex items-center justify-between', className)}>
      <RatingItemNumber value={value} />
      {selected ? <CheckmarkOutline className="h-20 w-20 fill-current text-text-primary" /> : null}
    </Box>
  );
};

export default RatingItem;
